import { forwardRef } from 'react';

import { cn } from '../lib/utils';

const Textarea = forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        `bg-background text-foreground ring-offset-background placeholder:text-steel-300 focus-within:border-brand-400`,
        `hover:focus-within:border-brand-400 flex h-10 w-full grow flex-row overflow-hidden rounded-xs border px-3`,
        `py-2 text-base placeholder:font-light focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50`,
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
